<template>
  <div class="type-box" v-if="$route.path=='/type'">
    <van-search @click="navToSearch" placeholder="请输入搜索关键词" />
    <van-row class="type-content-box">
      <van-col span="6">
        <van-sidebar v-model="activeKey" v-if="sidebarList">
          <van-sidebar-item :title="item.name" v-for="(item,index) in sidebarList.categoryList" :key="index" @click="getUiGory(item.id)" />
        </van-sidebar>
      </van-col>
      <van-col class="type-content" span="18" v-if="sidebarList">
        <van-row class="type-right">
          <div v-if="parentCategory" class="type-top-img">
            <img :src="parentCategory.picUrl" alt="">
          </div>
          <van-divider class="divider">
            {{currentCategoryName}}分类
          </van-divider>
          <van-col class="gory-item" span="8" v-for="(item,index) in goryList" :key="index" @click="navToTypeList(item.id)">
            <img :src="item.iconUrl" alt />
            <div>{{item.name}}</div>
          </van-col>
        </van-row>
      </van-col>

    </van-row>

  </div>
  <div class="type-box-detail" v-else>
    <router-view v-if="RouterState"></router-view>

  </div>
</template>

<script>
import { getType, getGory } from "@/api/index";

export default {
  name: "typeBase",
  provide() {
    return { reload: this.reload };
  },
  data() {
    return {
      activeKey: 0,
      sidebarList: null,
      goryList: null,
      currentCategory: null,
      RouterState: true,
      parentCategory: null,
    };
  },

  mounted() {
    getType().then((res) => {
      if (res.data.errno == 0) {
        this.sidebarList = res.data.data;
        this.currentCategory = res.data.data.currentCategory;
        this.currentCategoryName = res.data.data.currentCategory.name;
        this.goryList = res.data.data.currentSubCategory;
        this.getUiGory(res.data.data.categoryList[0].id);
      }
    });
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       if (this.$route.path == "/type") {

  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    reload() {
      this.RouterState = false;
      this.$nextTick(() => {
        this.RouterState = true;
      });
    },
    navToSearch() {
      this.$router.push({
        path: "/searchPage",
      });
    },
    getUiGory(id) {
      console.log(id);
      getGory(id).then((res) => {
        if (res.data.errno == 0) {
          this.goryList = res.data.data.brotherCategory;
          this.currentCategoryName = res.data.data.parentCategory.name;
          this.currentCategory = res.data.data.currentCategory;
          this.parentCategory = res.data.data.parentCategory;
        }
      });
    },
    navToTypeList(id) {
      this.$store.commit("SET_TYPELIST", null);
      this.$router.push({
        path: "/typelist",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-sidebar-item--select::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 100%;
  background-color: #49451b;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  content: "";
}
.type-box-detail {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  box-sizing: border-box;
  width: 100%;
}
.type-box {
  width: 100%;

  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  padding-bottom: 5rem;
  box-sizing: border-box;
  .type-content-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 0.5rem;
    .type-content {
      .type-right {
        .gory-item {
          img {
            height: 8rem;
            width: 8rem;
            margin: 0 auto;
          }
          div {
            text-align: center;
            margin: 1rem auto;
          }
        }
        .type-top-img {
          img {
            width: 100%;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
/deep/ .van-sidebar-item {
  padding: 1.5rem 0.7rem 1.5rem 0.5rem;
}
/deep/ .van-sidebar-item--select {
  color: #323233;
  font-weight: 500;
  border-color: #49451b;
  background-color: #fff;
}
/deep/ .van-divider {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/type/base.vue